import { memo, useEffect, useRef, useState } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './VideoPreviewShortVideo.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface VideoPreviewProps extends HTMLAttributes<HTMLDivElement> {
  src: string;
  cnPreviewHeight?: string;
  active?: boolean;
}

const VideoPreviewShortVideo: FC<VideoPreviewProps> = (props) => {
  const { active = true, src, className, cnPreviewHeight, ...restProps } = props;
  const videoRef = useRef<HTMLVideoElement>(null);
  const [poster, setPoster] = useState<string>(null);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    const handleLoadedMetadata = () => {
      // Устанавливаем текущий временной код на 0
      video.currentTime = 0;
    };

    const handleSeeked = () => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (!context) return;

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL();

      setPoster(dataUrl);

      // Убираем слушатели после получения кадра
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('seeked', handleSeeked);
    };

    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    video.addEventListener('seeked', handleSeeked);

    // Очистка обработчиков событий
    return () => {
      if (video) {
        video.removeEventListener('loadedmetadata', handleLoadedMetadata);
        video.removeEventListener('seeked', handleSeeked);
      }
    };
  }, [src]);

  return (
    <div {...restProps} className={cn(styles.videoPreview, { [styles.active]: active }, className)}>
      <video ref={videoRef} src={src} className={styles.video} crossOrigin='anonymous' />

      <div className={styles.container}>
        <Img
          className={cn(styles.posterImage, cnPreviewHeight)}
          src={poster}
          cnImage={styles.cnImage}
        />
        <div className={styles.playIcon} />
      </div>
    </div>
  );
};

export default memo(VideoPreviewShortVideo);
